import {
  AccountIcon,
  AlertIcon,
  // BookIcon,
  DownArrowOutlined, DownIcon,
  EyeIcon,
  JsonIcon,
  LinkOutlined,
  // StarIcon,
} from '@web/assets/icons';
import MarkdownTimeline from '@web/components/MarkdownTimeline';
import Day from '@web/components/Day';
import JsonViewer from '@web/ui/components/JsonViewer';
import {Checkbox, Statistic, Tag, Alert, Dropdown, Avatar, Progress} from 'antd';
// import {Link} from 'wouter';
import {Timestamp} from "firebase/firestore";
import UserAvatar from '@web/components/UserAvatar';
import Icon from '@web/components/Icon';
import Toggle from '@web/components/Toggle';
import UserContentPreview from '@web/components/UserContentPreview';
import ExternalLink from '@web/components/ExternalLink';
import dayjs from 'dayjs'
import now from "lodash/now"
// import Button from '@web/ui/components/Button';

const link = (value, key, indent) => {
  if (!value.includes?.(".")) {
    return <Toggle trigger={<span className="icon-btn green-color"><LinkOutlined /> {value.split("/")[2]}</span>}>
      <UserContentPreview path={value}>
      <div className="fat-chip">not found</div>
    </UserContentPreview>
    </Toggle>
    // return <Link to={value} className="icon-btn"><LinkOutlined /> {value.split("/")[2]}</Link>
  }
  if (key === "logo") {
    return <Avatar src={value} />
  }
  // regex to extract domain from url value
  const domain = value.match(/^(?:https?:\/\/)?(?:www\.)?([^\/]+)/)?.[1];
  return <ExternalLink
    href={value.startsWith("http") ? value : `https://${value}`}
    className="icon-btn"
    showIcon
  >
    {/*<LinkOutlined />*/}
    {domain}
  </ExternalLink>
}

const string = (value, key, indent) => {
  if (key === "key") console.log("string:key:", key, value);
  if (key === "timezone") {
    return <Tag color="magenta" className="rounded bolded">{value}</Tag>
  }

  if (key === "key" || key === "userId" || key === "type" || key === "status" || key === "event" || key === "queue" || key === "model" || key === "method" || key === "modelPerformance" || key === "stop" || key === "provider" || key === "mimeType" || key === "protocol") {
    return <Tag className="rounded muted bolded">{value}</Tag>;
  }
  if ((value.includes?.("/") || (key.includes("omain") && value.includes("."))) && !value?.includes(" ")) {
    return link(value, key, indent);
  }
  if (key.includes("agentId")) {
    return <Toggle
      trigger={<Tag color="magenta" className="rounded">{value}</Tag>}
    >
      <UserContentPreview path={"agents/" + value}>
        <span>Agent not found</span>
      </UserContentPreview>
    </Toggle>
  }
  if (key === "appName") {
    return <span className="capitalize font-lg bolded" style={{minWidth: 160, maxWidth: 900}}>{value}</span>;
  }
  if (key === "title" || key === "instructions" || key === "description" || key === "prompt" || key === "text" || key === "name" || key === "goal") {
    return <span className="font-lg bolded line-clamp-1" style={{minWidth: 240, maxWidth: 900}}>{value}</span>;
  }
  if (key.includes("icon")) {
    return <Icon name={value} />;
  }
  if (key.includes("actionNames") || key.includes("tools")) {
    return <Tag className="rounded" color="yellow">{value}</Tag>;
  }
  if (key === "contextTemplate" || key === "template" || key === "code" || key === "codeBlock") {
    return <span className="muted line-clamp-1 bga p-6" style={{maxWidth: 900}}>{value}</span>
  }
  if (key === "originId" || key === "id" || (value.length > 200 && !value.includes(" "))) {
    return <span className="font-lg space space-center-y muted" style={{minWidth: 240}}>key <EyeIcon size={20} /></span>;
  }
  if (key.includes("secret") && !value.includes(" ")) {
    return <span className="font-lg space space-center-y muted" style={{minWidth: 240}}>secret <EyeIcon size={20} /></span>;
  }
  return value.length < 200 ?
    <span className="font-lg ai-text line-clamp-1" style={{minWidth: 240, maxWidth: 900}}>{value}</span> :
    <MarkdownTimeline markdown={value} collapsible={{rows: 2}} style={{maxWidth: 900}} />;
}

const number = (value, key, indent) => {
  if (key === "date" || key.endsWith("Ts")) {
    return key === "date" ?
      <span className={"bolded"}  style={{minWidth: 240}}><Day ts={value} format={key === "date" ? "MMM DD YYYY hh:mm a" : ""} /></span> :
      <span className="font-sm muted" style={{minWidth: 240}}><Day ts={value} format={"MMM DD"} /></span>;
  }
  return <span className="font-md bolded" style={{minWidth: 240}}>{value}</span>;
}

const boolean = (value, key, indent) => {
  return <span className="font-lg ai-text" style={{minWidth: 240}}><Checkbox checked={value} disabled /></span>;
}

export const formatKey = (key, value, indent) => {
  return <span
    className="font-lg muted baseline"
    style={{width: "30%", minWidth: "30%"}}
  >
    {key.endsWith("Ts") ? key.replace("Ts", "") : key.includes("___") ? "file" : <span className="line-clamp-1" style={{width: "80%"}}>{key}</span>}
  </span>
}

const toDropdown = (list, key) => {
  // console.log("toDropdown", list);
  return <Dropdown.Button
    key={key}
    trigger={["hover", "click"]}
    placement="bottomRight"
    arrow
    icon={<DownArrowOutlined className="muted-icon" style={{marginBottom: "-5px"}} />}
    menu={{
      items: list.map((item, index) => {
        return {
          key: index,
          label: <span>{formatField(key, item)}</span>,
          // value: item,
        }
      }),
    }}
  >{list.length} items</Dropdown.Button>
}

export const formatField = (key, value, indent) => {
  if (typeof value === "string") {
    return string(value, key.split(".").pop(), indent);
  } else if (typeof value === "number") {
    return number(value, key, indent);
  } else if (typeof value === "boolean") {
    return boolean(value, key, indent);
  } else if (key.includes("memberUserIds")) {
    return <div className="space space-center-y">
      {value?.map?.((userId) => <UserAvatar size={30} key={userId} user={userId} icon={<AccountIcon size={28} className="muted-icon" />} />)}
    </div>
  }
  // arrays
  else if (Array.isArray(value)) {
    // if (typeof value[0] === "object") {
    //   return value.map((item) => formatField(key, item, indent))
    // }

    // if (key.includes("labels") || key.includes("tags") || key.includes("labelIds")) {
    //   return toDropdown(value, key)
    // }

    return toDropdown(value, key)
  }
  else if (typeof value === "object") {
    if (value instanceof Timestamp) {
      return <span className="font-sm bolded ai-text" style={{minWidth: 240}}><Day ts={value.valueOf()} format={"MMM DD"} /></span>;
    }
    if (key.includes("alert")) {
      return <Alert icon={<AlertIcon />} banner type={value.type} message={value.message} key={key} />
    }
    return <JsonViewer json={value} indent={indent}>
      <span className="space space-center-y green-color">
        <JsonIcon size={26} /> <DownArrowOutlined />
      </span>
    </JsonViewer>
  }
  return null;
}
